export default __webpack_public_path__ + "static/media/9.e1a557a1.jpg";